import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OverlayService {
    private readonly _globalOverlaySource = new BehaviorSubject<boolean>(true);
    public readonly globalOverlayObs = this._globalOverlaySource.asObservable();

    constructor() {}

    setGlobalOverlay(show: boolean): void {
        this._globalOverlaySource.next(show);
    }
}
